<template>
  <router-view />
</template>


<script setup>
import { ref, onMounted } from 'vue';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '@/firebase';
import { useAuthStore } from '@/stores/auth';

import { mapFirebaseError } from '@/utils.js';

const authStore = useAuthStore();
const appReady = ref(false);

onMounted(() => {
  onAuthStateChanged(auth, (user) => {
    authStore.user = user;
    appReady.value = true;
  });
});
</script>
